import { InjectableClass } from '@fino/lib-injection';
import { FormRule } from '../../../../../common/ui/form/FormRule';

export class TransferringConfirmWarrantService extends InjectableClass {
  constructor(appConfig, formControlService, $document) {
    'ngInject';
    super({ appConfig, formControlService, $document });

    this.formRules = {
      oldIban: new FormRule(this.compareOldWithNewIban()),
      newIban: new FormRule(this.compareOldWithNewIban()),
    };
  }

  setFormRules(rules) {
    angular.extend(this.formRules, rules);
  }

  getFormRules() {
    return this.formRules;
  }

  compareOldWithNewIban() {
    return (form, model, key, injections, newVal) => {
      const { oldIban, newIban } = model;

      if (key === 'newIban') {
        model.foreignIbanExpandable =
          newIban && !newIban.toLowerCase().startsWith('de');
      }

      if (angular.isUndefined(newVal)) {
        return;
      }
      // Validate form control to show error when old and new ibans are equal
      this.formControlService.setValidity(
        form[key],
        'type',
        oldIban !== newIban,
      );
    };
  }
}
